// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lai-modal-close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  font-size: 22px;
  color: #888;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.lai-modal-close:hover {
  background: #f0f0f0;
  color: #333;
}

.lai-modal-icon {
  text-align: center;
  font-size: 34px;
  color: #5616ea;
  background: #f0eaff;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin: 0 auto 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lai-modal-title {
  margin: 0 0 12px;
  text-align: center;
  font-size: 1.2rem;
  color: #222;
  font-weight: 600;
}

.lai-modal-body {
  font-size: 0.95rem;
  line-height: 1.55;
  color: #555;
  margin-bottom: 22px;
  text-align: center;
}

.lai-modal-body p {
  margin: 0 0 12px;
}

.lai-modal-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.lai-modal-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  /* Anchors don't get the user-agent's button box-sizing, so width:100% +
     padding overflows the column for the <a> variant. Force border-box on
     all variants so primary/secondary/ghost line up perfectly. */
  box-sizing: border-box;
  padding: 11px 14px;
  border: none;
  border-radius: 8px;
  background-color: #5616ea;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.2s ease, transform 0.1s ease;
  font-family: inherit;
}

.lai-modal-btn:hover {
  background-color: #4a14d6;
}

.lai-modal-btn:active {
  transform: translateY(1px);
}

.lai-modal-btn.secondary {
  background-color: transparent;
  color: #5616ea;
  border: 1.5px solid #5616ea;
}

.lai-modal-btn.secondary:hover {
  background-color: rgba(86, 22, 234, 0.06);
}

.lai-modal-btn.ghost {
  background-color: transparent;
  color: #777;
  border: none;
  font-weight: 500;
  font-size: 13px;
  padding: 6px 14px;
}

.lai-modal-btn.ghost:hover {
  color: #333;
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/components/LiveAgentInfoModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX;;iEAE+D;EAC/D,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,2DAA2D;EAC3D,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B","sourcesContent":[".lai-modal-close {\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 12px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 22px;\r\n  color: #888;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n  transition: background-color 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n.lai-modal-close:hover {\r\n  background: #f0f0f0;\r\n  color: #333;\r\n}\r\n\r\n.lai-modal-icon {\r\n  text-align: center;\r\n  font-size: 34px;\r\n  color: #5616ea;\r\n  background: #f0eaff;\r\n  width: 64px;\r\n  height: 64px;\r\n  border-radius: 50%;\r\n  margin: 0 auto 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.lai-modal-title {\r\n  margin: 0 0 12px;\r\n  text-align: center;\r\n  font-size: 1.2rem;\r\n  color: #222;\r\n  font-weight: 600;\r\n}\r\n\r\n.lai-modal-body {\r\n  font-size: 0.95rem;\r\n  line-height: 1.55;\r\n  color: #555;\r\n  margin-bottom: 22px;\r\n  text-align: center;\r\n}\r\n\r\n.lai-modal-body p {\r\n  margin: 0 0 12px;\r\n}\r\n\r\n.lai-modal-actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.lai-modal-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  /* Anchors don't get the user-agent's button box-sizing, so width:100% +\r\n     padding overflows the column for the <a> variant. Force border-box on\r\n     all variants so primary/secondary/ghost line up perfectly. */\r\n  box-sizing: border-box;\r\n  padding: 11px 14px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background-color: #5616ea;\r\n  color: #fff;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  transition: background-color 0.2s ease, transform 0.1s ease;\r\n  font-family: inherit;\r\n}\r\n\r\n.lai-modal-btn:hover {\r\n  background-color: #4a14d6;\r\n}\r\n\r\n.lai-modal-btn:active {\r\n  transform: translateY(1px);\r\n}\r\n\r\n.lai-modal-btn.secondary {\r\n  background-color: transparent;\r\n  color: #5616ea;\r\n  border: 1.5px solid #5616ea;\r\n}\r\n\r\n.lai-modal-btn.secondary:hover {\r\n  background-color: rgba(86, 22, 234, 0.06);\r\n}\r\n\r\n.lai-modal-btn.ghost {\r\n  background-color: transparent;\r\n  color: #777;\r\n  border: none;\r\n  font-weight: 500;\r\n  font-size: 13px;\r\n  padding: 6px 14px;\r\n}\r\n\r\n.lai-modal-btn.ghost:hover {\r\n  color: #333;\r\n  background-color: transparent;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
